import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { FILE_PREVIEW_DIALOG_DATA } from 'src/app/shared/custom-overlay/cdk-overlay-injector';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { AlertsvarService } from '../../alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-advance-filter',
  templateUrl: './advance-filter.component.html',
  styleUrls: ['./advance-filter.component.scss']
})
export class AdvanceFilterComponent implements OnInit {
  constructor(
    private timezoneservice: TimeZoneService,
    public alertVarService:AlertsvarService,
    private sharedService: SharedService,
    private overLayRef: cdkOverlayRef,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public data: any,
    private http: HttpClient,

  ) {
  }
  // formatDate(date: Date): string {
  //   return date.toISOString().slice(0, 16); // Format to 'yyyy-MM-ddTHH:mm'
  // }  
  // minDateTime: string = this.formatDate(new Date()); // Current date and time
  // maxDateTime: string = this.formatDate(new Date(new Date().setDate(new Date().getDate() + 7))); // One week from now
  maxdate = this.timezoneservice.getcurrentuserTime().format('YYYY-MM-DD HH:mm:ss');
  mindate = this.timezoneservice.toUserTimeZone(this.sharedService.timeRange.alert_time_range[0]).format('YYYY-MM-DD HH:mm:ss');

  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });
  filteredUsers = []
  advanceFilter_metadata = this.data[1]
  ishighlight_relativetime = this.data[0].highlight;
  mode = this.data[2];
  errorObj = null;
  errorMsg = "";
  Errormsg = { time: "time range is wrong" }
  currentdate = this.timezoneservice.getcurrentuserTime();
  advanceFilterErrorHandler = new ErrorMsgHandler();

  searchValue = new FormControl('');
  advanceFilter = new FormGroup({
    fromDate: new FormControl(''),
    toDate: new FormControl(''),
    interval: new FormControl(''),
    count: new FormControl(0)
  })
  ngOnInit() {
    this.setDefaultState()

  }

  relativeTime_click(time) {
    this.ishighlight_relativetime = time.disp;
    // console.log(this.alertVarService)
    // var timerange = this.alertVarService.calculate_timerange(time.value)
    var timerange = this.processrelativetime(time.value)
    this.fromDate.reset(timerange[0], { emitEvent: false })
    this.toDate.reset(timerange[1], { emitEvent: false })
  }
  processrelativetime(time: any) {
    const currentusertime = this.timezoneservice.getcurrentuserTime();
    if (time[1] == "hour") {
      const start_date = currentusertime.clone().subtract(time[2], 'hour');
      return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "today") {
      const start_date = currentusertime.clone();
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "yesterday") {
      const start_date = currentusertime.clone().subtract(1, 'days');
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    } else {
      const previousdate = currentusertime.clone().subtract(time[2], 'days');
      return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    }
  }

  setDefaultState() {
    // console.log(this.data[0])
    // 2024-10-28 12:11:15
    // this.advanceFilter.controls.fromDate.setValue('2024-09-02 00:00:00');
    this.advanceFilter.controls.fromDate.setValue(this.data[0].start_time);
    // this.advanceFilter.controls.toDate.setValue('2024-09-02 01:00:00');
    this.advanceFilter.controls.toDate.setValue(this.data[0].end_time);
    this.advanceFilter.controls.interval.setValue(this.data[0].time_interval.value)
    this.advanceFilter.controls.count.setValue(this.data[0].count)
  }

  get fromDate() {
    return this.advanceFilter.get('fromDate') as FormControl;
  }
  get toDate() {
    return this.advanceFilter.get('toDate') as FormControl;
  }
  get interval() {
    return this.advanceFilter.get('interval') as FormControl;
  }
  get count() {
    return this.advanceFilter.get('count') as FormControl;
  }


  applyClick() {
    this.errorObj = this.filterValidation()
    if (!this.errorObj) {
      const filters = this.filter_result()
      this.overLayRef.submit(filters)
      this.overLayRef.close()
    }
  }
  filter_result() {
    var result = {
      "start_time": "",
      "end_time": "",
      "time_interval": {},
      "count": 0,
      "highlight": this.ishighlight_relativetime,
    }
    // result.start_time = this.fromDate.value
    // result.end_time = this.toDate.value
    // result.start_time = this.timezoneservice.toUtcTimeZonefromUser(this.fromDate.value).format('YYYY-MM-DD HH:mm:ss');
    // result.end_time = this.timezoneservice.toUtcTimeZonefromUser(this.toDate.value).format('YYYY-MM-DD HH:mm:ss');
    result.start_time = this.fromDate.value
    result.end_time = this.toDate.value
    result.count = this.count.value
    this.advanceFilter_metadata.intervals.forEach(element => {
      if (element.value == this.interval.value) {
        result.time_interval = element
      }
    });
    return result
  }
  cancelClick() {
    this.overLayRef.close()
  }

  filterValidation() {
    var errorObj = null
    const start = this.timezoneservice.setcurrentuserTime(this.fromDate.value);
    const end = this.timezoneservice.setcurrentuserTime(this.toDate.value);

    if (end.unix() - start.unix() < 0) {
      errorObj = { ...errorObj, ...{ time: true } }
    }
    return errorObj;
  }
}
